import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../../common/components/SearchHeader/filters/useSearchFilters';
import { useHannibalQuery } from '../../../../common/schema/hannibal/HannibalContext';
import { InsuranceFilterOptionsDocument } from '../../../../common/schema/hannibal/types.generated';
import { useVariables } from '../../../useSearchQuery/useVariables';
import { DropDownEnumFilter } from '../../EnumFilter/DropDownEnumFilter/DropDownEnumFilter';
import { DropDownFilterPill } from '../../FilterPill/DropDownFilterPill';
import { useOverlay } from '../../overlay/OverlayContext';

interface Props {
  preferredHealthProviderCount?: number;
}

const TITLE = 'Insurance';

export const InsuranceFilter = ({ preferredHealthProviderCount }: Props) => {
  const [filters, setFilters] = useSearchFilters();
  const { insurance } = filters;

  const handleClear = () => {
    setFilters({ ...filters, insurance: undefined, insuranceProgram: undefined });
  };

  if (preferredHealthProviderCount === 0) return null;

  return (
    <DropDownFilterPill
      hasValue={insurance !== undefined}
      onClear={handleClear}
      caption={insurance ?? TITLE}
      trackingId={LinkId.FILTER_BY_INSURANCE_BUTTON}
      content={<FilterContent />}
    />
  );
};

const FilterContent = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();
  const { insurance } = filters;

  const handleChange = (insurance: string | undefined): void => {
    setFilters({ ...filters, insurance, insuranceProgram: undefined });
    clear();
  };

  const queryResult = useHannibalQuery(InsuranceFilterOptionsDocument, {
    variables: useVariables(filters),
  });

  const insuranceOptions =
    queryResult.data?.searchProfiles.facetsWithCounts.preferredHealthProviders.values?.map(
      facetResult => ({
        label: facetResult.term,
        value: facetResult.term,
      }),
    ) || [];

  return (
    <DropDownEnumFilter<string | undefined>
      caption="Choosing to undergo treatment with your health insurer's preferred provider could help you avoid or limit any out-of-pocket expenses."
      value={insurance}
      filterTitle="Preferred insurance"
      options={insuranceOptions}
      onChange={handleChange}
    />
  );
};
